import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';


import { PriorityOption } from 'src/app/interfaces/priority.model';
import { PrioritiesConfig } from 'src/app/constants/Priority';
import { SvgIconComponent } from "../../components/svg-icon/svg-icon.component";


@Component({
    selector: 'app-priority-pill',
    imports: [CommonModule],
    templateUrl: './priority-pill.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./priority-pill.component.css']
})
export class PriorityPillComponent implements OnChanges {

  @Input("value") value: any;
  @Input("editable") editable: boolean;
  @Input("options") options: PriorityOption[] = PrioritiesConfig
 
  selectedOption: PriorityOption = null;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.value){
      this.selectedOption = this.options.find(x => x.value.id == this.value)
    }
  }
}
